module.exports = __webpack_public_path__ + "01_short_gold.7beec3a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_short_gold.png
// module id = FGd0
// module chunks = 0